var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * React glue for the ChatGPT embed: hands the Redux store and the PlayCanvas
 * application to the EmbedApi singleton, hooks telemetry and the quality knob.
 * Rendered inside StoreProvider + PlaycanvasApplicationProvider (routes.tsx),
 * only in embed mode. Renders nothing.
 */
import { useEffect, useRef } from "react";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useStore } from "react-redux";
import { getEmbedApi } from "./embed-api";
import { getQualitySettings } from "./embed-quality";
import { attachTelemetryApp, attachTelemetryCanvas, emitTelemetrySceneLoaded, } from "./embed-telemetry";
import { usePlaycanvasApplicationContext } from "providers/playcanvas-application";
import { actions } from "store/actions";
import { persistConfigs } from "store/persist";
export var EmbedBridge = function () {
    var store = useStore();
    var _a = usePlaycanvasApplicationContext(), app = _a.app, camera = _a.camera, canvasRef = _a.canvasRef, isLoading = _a.isLoading, isCameraMoving = _a.isCameraMoving;
    var movingRef = useRef(false);
    movingRef.current = !!isCameraMoving;
    var qualityApplied = useRef(false);
    useEffect(function () {
        var _a;
        var saveConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
            var persistParts, persistConfigs_1, persistConfigs_1_1, config, stored, id;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        persistParts = [];
                        try {
                            for (persistConfigs_1 = __values(persistConfigs), persistConfigs_1_1 = persistConfigs_1.next(); !persistConfigs_1_1.done; persistConfigs_1_1 = persistConfigs_1.next()) {
                                config = persistConfigs_1_1.value;
                                stored = window.sessionStorage.getItem("persist:".concat(config.key));
                                if (stored)
                                    persistParts.push({ persistKey: config.key, data: stored });
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (persistConfigs_1_1 && !persistConfigs_1_1.done && (_a = persistConfigs_1.return)) _a.call(persistConfigs_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        if (!persistParts.length)
                            return [2 /*return*/, undefined];
                        return [4 /*yield*/, store
                                .dispatch(actions.saveConfiguration({ persistParts: persistParts }))
                                .unwrap()];
                    case 1:
                        id = (_b.sent()).id;
                        return [2 /*return*/, id];
                }
            });
        }); };
        getEmbedApi().attach({
            store: store,
            app: app,
            camera: camera,
            canvas: (_a = canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.current) !== null && _a !== void 0 ? _a : null,
            isCameraMoving: function () { return movingRef.current; },
            saveConfiguration: saveConfiguration,
        });
    }, [store, app, camera, canvasRef, isLoading]);
    useEffect(function () {
        if (!app)
            return;
        attachTelemetryApp(app);
        if (canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.current)
            attachTelemetryCanvas(canvasRef.current);
        if (!qualityApplied.current) {
            qualityApplied.current = true;
            var q = getQualitySettings();
            if (q.maxPixelRatio !== undefined)
                app.graphicsDevice.maxPixelRatio = Math.min(app.graphicsDevice.maxPixelRatio, q.maxPixelRatio);
        }
    }, [app, canvasRef]);
    useEffect(function () {
        if (app && !isLoading)
            emitTelemetrySceneLoaded();
    }, [app, isLoading]);
    return null;
};
